import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import type { StaticEclipseBlockchainConfig } from "../types"

export const eclipseMainnetConfig: StaticEclipseBlockchainConfig = {
  name: "Eclipse",
  isEvm: false,
  icon: "/images/blockchains/eclipse.svg",
  chainId: "201",
  blockchain: Blockchain.ECLIPSE,
  unionApi: "https://api.rarible.org",
  rpcUrls: [{ url: "https://rarible.fun/nodes/eclipse-node", isPublic: false }],
  privateRpcNodeSlug: "eclipse-node",
  marketProgramAddress: "Rari4ReeeT8bhbsRGP5J8RBhTFXTAP7iMm7VHuNQTs5",
  primaryCurrency: {
    id: toCurrencyId("ECLIPSE:So11111111111111111111111111111111111111112"),
    symbol: "ETH",
    name: "ETH",
    decimals: 18,
  },
  blockExplorers: [
    {
      url: "https://explorer.eclipse.xyz",
      icon: "/images/scanner.svg",
      adress: "https://explorer.eclipse.xyz/address/${adrress}",
    },
  ],
  isTestnet: false,
  hasStabilityProtocol: true,
}

export const eclipseTestnetConfig: StaticEclipseBlockchainConfig = {
  name: "Eclipse",
  isEvm: false,
  icon: "/images/blockchains/eclipse.svg",
  chainId: "201",
  blockchain: Blockchain.ECLIPSE,
  unionApi: "https://testnet-api.rarible.org",
  rpcUrls: [
    {
      url: "https://rarible.fun/nodes/testnet-eclipse-node",
      isPublic: false,
    },
  ],
  privateRpcNodeSlug: "testnet-eclipse-node",
  marketProgramAddress: "Rari4ReeeT8bhbsRGP5J8RBhTFXTAP7iMm7VHuNQTs5",
  primaryCurrency: {
    id: toCurrencyId("ECLIPSE:So11111111111111111111111111111111111111112"),
    symbol: "ETH",
    name: "ETH",
    decimals: 18,
  },
  blockExplorers: [
    {
      url: "https://explorer.eclipse.xyz",
      icon: "/images/scanner.svg",
      adress: "https://explorer.eclipse.xyz/address/${adrress}",
    },
  ],
  isTestnet: true,
  hasStabilityProtocol: true,
}

export function getEclipseConfig(
  hostEnvironment: "mainnet" | "testnet" | "dev" | "beta",
): StaticEclipseBlockchainConfig {
  switch (hostEnvironment) {
    case "mainnet":
      return eclipseMainnetConfig
    case "beta":
      return eclipseMainnetConfig
    case "testnet":
      return eclipseTestnetConfig
    case "dev":
      return eclipseTestnetConfig
  }
}
